import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function Login({ onSuccess }) {
  const [formData, setFormData] = useState({});
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const handleChange = (field) => (e) => {
    setFormData({
      ...formData,
      [field]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    fetch("/sis/login", {
      method: "post",
      body: JSON.stringify(formData),
      headers: {
        "Content-Type": "application/json",
      },
    }).then((res) => {
      if (res.ok) {
        navigate('/');
      } else {
        setError("Wrong username or password.");
      }
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        placeholder="DB_USERNAME"
        value={formData.username || ""}
        onChange={handleChange("username")}
        required
      />
      <input
        type="password"
        placeholder="DB_PASSWORD"
        value={formData.password || ""}
        onChange={handleChange("password")}
        required
      />
     <button type="submit">Login</button>
      <p style={{ color: "red" }}>{error}</p>
    </form>
  );
}

export default Login;
